// Formatos de la pantalla de Vendedores: dinero y forma de pago.
import type { BackofficeSale } from '@/api/services/retail-wizard/contract';
import { FINANCIER_LABEL, financierOfSale } from '../../lib/financier';

const MXN = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });

/** `null` es «no sé» y se pinta «—»; un `$0` diría «no vendió». */
export function money(cents: number | null): string {
    return cents === null ? '—' : MXN.format(cents / 100);
}

/** Forma de pago con nombre completo: Contado, Crédito SK o la financiera. `null` si no se sabe. */
export function paymentLabel(
    sale: Pick<BackofficeSale, 'type' | 'externalProvider'>,
): string | null {
    const financier = financierOfSale(sale);
    if (financier === null) return null;
    if (financier === 'SUREKEEP') return 'Crédito SK';
    return FINANCIER_LABEL[financier];
}
